<template>
    <article :class="[content.vertical, 'feed-item']">
        <header>
            <h2>{{ content.heading }}</h2>
            <!--<div class="checkbox-container" v-if="showControls">
                <input type="checkbox" />
                <div class="checkbox"></div>
            </div>-->
        </header>
        <div class="content">
            <div class="row">
                <p class="column">{{date(content.dateTime)}}</p>
                <p class="column product">{{content.product}}</p>
            </div>
            <p :class="{'no-margin': !showControls || !content.contentUrl}">{{ content.body }}</p>
            <router-link :to="`/performance/highlights/${content.code}/${encodeURIComponent(content.product)}`" v-if="showControls && content.contentUrl">Read more <svg viewBox="0 0 24 24"><path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" /></svg></router-link>
        </div>
    </article>
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex'
    import { Insight } from '../vuex/models'

    export default {
        name: 'FeedItem',
        props: {
            content: {
                type: Insight,
                required: true
            },
            showControls: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            ...mapGetters(['views'])
        },
        methods: {
            ...mapMutations(['SELECT_CONTENT']),
            selectContent() {
                let content = this.content

                this.SELECT_CONTENT(content)
            },
            date(val) {
                let d = new Date(val)
                return `${d.getDate().toString().padStart(2, '0')}/${(d.getMonth() + 1).toString().padStart(2, '0')}/${d.getFullYear()}`
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use 'sass:math';
    @import '../styles/base';
    @import '../../node_modules/hd-styles/modules/mixins';

    .feed-item {
        margin-bottom: $spacing-unit;
        border: solid $border-width;
        border-radius: $border-radius-large;
    }

    header {
        padding: math.div($spacing-unit, 4) math.div($spacing-unit, 2);
        display: flex;
        justify-content: space-between;
        align-items: center;
        
    }

    h2 {
        @include rem(font-size, 16px);
        font-weight: 500;
        margin: 0;
        color: $white;
    }

    input[type=checkbox] {
        width: $spacing-unit;
        height: $spacing-unit;
        display: block;
        opacity: 0;

        &:checked + .checkbox::after {
            pointer-events: none;
            top: 0;
            position: absolute;
            display: block;
            content: url('data:image/svg+xml; utf8, <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 24 24"><path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" /></svg>');
            width: $spacing-unit;
            height: $spacing-unit;
        }
    }

    .checkbox-container {
        position: relative;
    }

    .checkbox {
        &::before {
            position: absolute;
            top: 0;
            pointer-events: none;
            content: '';
            display: block;
            background-color: $white;
            border: solid $border-width $grey;
            border-radius: $border-radius-large;
            height: $spacing-unit;
            width: $spacing-unit;
        }
    }

    .content {
        padding: math.div($spacing-unit, 2);
    }

    a {
        color: $pink;
        text-decoration: none;
        display: inline-block;
    }

    .no-margin {
        margin: 0;
    }

    svg {
        fill: $pink;
        transform: rotate(-90deg);
        height: $spacing-unit;
        display: inline-block;
        vertical-align: bottom;
    }

    .row {
        display: inline-flex;
        width: 100%;
        @include rem(font-size, 14px);
    }

    .column {
        width: 50%;
        margin-bottom: 0;
        font-weight: 600;
    }

    .product {
        text-align: right;
        text-transform: capitalize;
    }

    .Cards {
        border-color: $pink;

        header {
            background-color: $pink;
        }
    }

    .Loans {
        border-color: $blue-mid;

        header {
            background-color: $blue-mid;
        }
    }
</style>
